export default defineNuxtPlugin((nuxtApp) => {
    const bugsnag = useRuntimeConfig().public.bugsnag;
    const isBugsnagEnabled = !!bugsnag?.apiKey;

    if (!isBugsnagEnabled) {
        return;
    }

    nuxtApp.vueApp.config.errorHandler = (error) => {
        if (error instanceof Error || typeof error === 'string') {
            useBugsnag().notify(error);
        }
    };

    nuxtApp.hook('vue:error', (error) => {
        if (error instanceof Error || typeof error === 'string') {
            useBugsnag().notify(error);
        }
    });
});
